import axios from "axios"

import { ENV } from "../constants/env"

const headers = {
  Accept: "application/vnd.api+json",
  "Content-Type": "application/vnd.api+json",
  ...(ENV.X_SOURCE_ORIGIN
    ? {
        Origin: ENV.SITE_URL,
        "X-Source-Origin": ENV.X_SOURCE_ORIGIN,
        "CF-Access-Client-Id": ENV.CF_CLIENT_ID,
        "CF-Access-Client-Secret": ENV.CF_SECRET
      }
    : {})
}

export const baseRequest = axios.create({
  baseURL: `${ENV.API_BASE}`,
  withCredentials: true,
  headers
})
